import { render, staticRenderFns } from "./CookieNoty.vue?vue&type=template&id=8e832ff0&scoped=true&"
import script from "./CookieNoty.vue?vue&type=script&lang=js&"
export * from "./CookieNoty.vue?vue&type=script&lang=js&"
import style0 from "./CookieNoty.vue?vue&type=style&index=0&id=8e832ff0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e832ff0",
  null
  
)

export default component.exports